export const AppModule = {
    namespaced: true,
    state: () => {
        const { innerWidth } = window;
        return {
            isMobile: innerWidth <= 1000,
            scrollX: 0,
            scrollY: 0,
            windowWidth: 0,
            windowHeight: 0,
            pageHeight: 0,
            pageWidth: 0,
            headerHeight: 0,
            headerFloatHeight: 0,
            headerFloatTop: 0,
            headerBodyHeight: 0,
            headerHideOnScroll: false,
            baseViewportWidth: 1440,
            baseMobileViewportWidth: 360,
            headerIsSticky: false,
            headerStatic: false,
        };
    },
    mutations: {
        SET_IS_MOBILE(state, val) {
            state.isMobile = val;
        },
        SET_SCROLL_X(state, val) {
            state.scrollX = val;
        },
        SET_SCROLL_Y(state, val) {
            state.scrollY = val;
        },
        SET_WINDOW_WIDTH(state, val) {
            state.windowWidth = val;
        },
        SET_WINDOW_HEIGHT(state, val) {
            state.windowHeight = val;
        },
        SET_PAGE_HEIGHT(state, val) {
            state.pageHeight = val;
        },
        SET_PAGE_WIDTH(state, val) {
            state.pageWidth = val;
        },
        SET_HEADER_HEIGHT(state, val) {
            state.headerHeight = val;
        },
        SET_HEADER_FLOAT_HEIGHT(state, val) {
            state.headerFloatHeight = val;
        },
        SET_HEADER_FLOAT_TOP(state, val) {
            state.headerFloatTop = val;
        },
        SET_HEADER_BODY_HEIGHT(state, val) {
            state.headerBodyHeight = val;
        },
        SET_HEADER_HIDE_ON_SCROLL(state, val) {
            state.headerHideOnScroll = val;
        },
        SET_HEADER_IS_STICKY(state, val) {
            state.headerIsSticky = val;
        },
        SET_HEADER_STATIC(state, val) {
            state.headerStatic = val;
        },
    },
    getters: {
        /**
         * Отступ, равный фикс хэдеру
         */
        mainTopOffsetScrolled(state, getters ) {
            const offset = state.headerHideOnScroll ? state.headerFloatTop + state.headerFloatHeight : state.isMobile ? getters.headerTopHeight : state.headerBodyHeight;
            return !state.isMobile && state.headerStatic ? 0 : offset;
        },
        headerTopHeight(state) {
            return state.headerHeight - state.headerBodyHeight;
        }
    },
};
